import React, { memo, useEffect, useState } from 'react';
import styles from './styles.module.css';
import { connect } from 'react-redux';
import { showAlert } from '../../../../../common/actions';
import { useNavigate, useParams } from 'react-router-dom';
import { getCategoryById, updateCategory } from '../../actions';
import { Button, Input } from '../../../../../common/ui';
import PropTypes from 'prop-types';

const UpdateCategory = memo(({
  categoriesState: { searchByIdCategoryData },
  showAlert,
  getCategoryById,
  updateCategory,
}) => {
  const { id } = useParams();
  const [isLoading, setLoading] = useState(false);
  const [nameError, setNameError] = useState('');
  const navigate = useNavigate();
  const [updateForm, setUpdateForm] = useState({
    name: '',
    datecreated: '',
  });

  useEffect(() => {
    if (id) getCategoryById(id);
  }, [id, getCategoryById]);

  useEffect(() => {
    if (searchByIdCategoryData) {
      setUpdateForm((prev) => ({
        ...prev,
        name: searchByIdCategoryData.name ?? '',
        datecreated: searchByIdCategoryData.datecreated ?? '',
      }));
    }
  }, [searchByIdCategoryData]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const name = (updateForm.name ?? '').trim();
    if (!name) {
      setNameError('Please enter a category name.');
      return;
    }
    setNameError('');
    setLoading(true);
    const isSuccess = await updateCategory(id, { id, ...updateForm, name });
    setLoading(false);
    if (isSuccess) {
      showAlert({
        isAlertOpen: true,
        alertType: 'success',
        alertMessage: 'Category updated successfully.',
      });
      navigate('/inventory/categories');
    } else {
      showAlert({
        isAlertOpen: true,
        alertType: 'danger',
        alertMessage: 'Operation failed. Please try again later.',
      });
    }
  };

  const handleCancel = () => {
    navigate('/inventory/categories');
  };

  return (
    <div className={styles.container}>
      <header className={styles.header}>
        <h1 className={styles.pageTitle}>Update Category</h1>
      </header>
      <div className={styles.body}>
        <form onSubmit={handleSubmit} noValidate className={styles.formCard}>
          <div className={styles.formSection}>
            <div className={styles.fieldGroup}>
              <Input
                label="ID"
                type="text"
                value={id ?? ''}
                disabled
              />
            </div>
            <div className={styles.fieldGroup}>
              <Input
                label="Name"
                type="text"
                value={updateForm.name ?? ''}
                onChange={(value) => {
                  setUpdateForm((prev) => ({ ...prev, name: value }));
                  if (nameError) setNameError('');
                }}
                placeholder="Category name"
                error={nameError}
              />
            </div>
            <div className={styles.fieldGroup}>
              <Input
                label="Created Date"
                type="text"
                value={updateForm.datecreated ?? ''}
                disabled
              />
            </div>
          </div>
          <div className={styles.buttonPanel}>
            <Button type="submit" disabled={isLoading}>
              {isLoading ? 'Loading...' : 'Submit'}
            </Button>
            <Button type="button" variant="secondary" onClick={handleCancel}>
              Cancel
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
});

UpdateCategory.propTypes = {
  categoriesState: PropTypes.shape({
    searchByIdCategoryData: PropTypes.object,
  }).isRequired,
  showAlert: PropTypes.func.isRequired,
  getCategoryById: PropTypes.func.isRequired,
  updateCategory: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  categoriesState: state.categoriesState,
});

export default connect(mapStateToProps, {
  getCategoryById,
  updateCategory,
  showAlert,
})(UpdateCategory);
